module.exports = __webpack_public_path__ + "img/leap-for-mankind.d9c50c21.png";